



import {Component, Mixins, Prop, Vue} from 'vue-property-decorator';
    import {ActiveInject} from "@/support/reactive";
    import {mixins} from "vue-class-component"
import MonitorMixin from "@/design-system/utilities/MonitorMixin"
import TableCellClassifiableMixin from "@/design-system/patterns/Table/TableCellClassifiableMixin"

    /**
     * @status stable
     * @published 2.0.0
     * @changelog 2.0.0 Published.
     * @changelog 3.0.0 Switched to accepting cent-value through `amount` and hiding cents by default.
     */
    @Component
    export default class JdsMoney extends Mixins(MonitorMixin, TableCellClassifiableMixin) {
        @ActiveInject({from: 'jds.locale', default: 'en-GB'}) locale!: string;

        /**
         * @required
         */
        @Prop() amount!: number;

        /**
         * @required
         */
        @Prop() currency!: string;

        mounted () {
            this.classifyAsInTable('number');
        }

        get display() {

            if (this.amount % 1 !== 0) {
                this.$error('Money only accepts amounts as whole numbers.')
                return '';
            }

            if (this.amount % 100 !== 0) {
                this.$warn('Money does not show amounts in cents, and the displayed amount is inaccurate.')
            }

            return (new Intl.NumberFormat(this.locale, {
                maximumFractionDigits: 0
            })).format(this.amount / 100) + ' ' + this.currency;
        }
    }
